import React from 'react'
import styles from './FancyCheckbox.scss'
import cx from 'classnames'

// not really very accessible, but that's what you get Mozilla for making your
// checkboxes completely non-CSS-styleable I mean FFS we sent a man to the moon
// and you're supposed to be a pioneering standards nonprofit or whatever, you
// can probably figure out how to let me style a checkbox so that it doesn't
// look like something that Steve Ballmer dreamed up in the early nineties.
// Until then, though, you get <div>s.
export const FancyCheckbox = ({size, selected, className, onClick}) => (
  <div onClick={onClick} className={cx(styles.FancyCheckbox, className, selected && styles.checked)} />
)
